import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';

import { useAvailablePath } from 'hooks/useRedirectLayout';
import { useAuthentication } from 'queries/session';

import { CustomButton, OptionalButtons } from './WrongPageLayout/styled';

import { PermissionDeniedIcon } from './styled';
import WrongPageLayout from './WrongPageLayout';

interface IPermissionDenied {
  onReset?: () => void;
}

const PermissionDenied: React.FC<IPermissionDenied> = ({ onReset }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { logout } = useAuthentication();
  const availablePath = useAvailablePath();

  const onGoMainPage = useCallback(() => {
    navigate('/');
    onReset?.();
  }, []);

  const onLogout = async () => {
    await logout();
    onReset?.();
  };

  return (
    <WrongPageLayout
      icon={<PermissionDeniedIcon />}
      subtitle={t('permissionDenied.subtitle')}
      title={t('permissionDenied.title')}
    >
      <OptionalButtons $isDouble={!!availablePath}>
        {availablePath && (
          <CustomButton onClick={onGoMainPage} variant='primary'>
            {t('common.goHomeButton')}
          </CustomButton>
        )}
        <CustomButton onClick={onLogout} variant='primary'>
          {t('logout.title')}
        </CustomButton>
      </OptionalButtons>
    </WrongPageLayout>
  );
};

export default PermissionDenied;
